/* eslint-disable no-unused-vars */
/*
 globals

 불러쓰는 메뉴에서 아래와 같이 사용하세요.

 임포트 방법
 const globals = require('./config/' + process.env.NODE_ENV + '/Portal/globals');
 */

/*** PROD API ***/
const globals = {
  // API
  // exApiUrl: 'http://localhost:8080',

  exApiUrl: 'https://eis.bir.gov.ph/api',
  // exApiUrl: 'http://172.31.16.11/api',
  // exApiUrl: 'http://10.51.114.83:8080',

  commonApiUrl: 'https://eis.bir.gov.ph/common',

  staticUrl: 'https://eis.bir.gov.ph/cdn',

  objectUrl: 'https://eis-obj.bir.gov.ph',
};

module.exports = globals;
